export const loanAccountL2Data = [
    {
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "product_name":"Productive Credit - KI Bank KORPORASI IDR",
        "product_level_credit_limit":1861500000000.0,
        "product_level_credit_outstanding":665212500000.0
    },
    {
        "company_name":"GARUDAFOOD PUTRA PUTRI JAYA TBK",
        "group_company":"GARUDAFOOD",
        "product_name":"Productive Credit - TL Bank KORPORASI IDR",
        "product_level_credit_limit":744600000000.0,
        "product_level_credit_outstanding":613200000000.0
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "product_name":"Import LC_Product added for UAT",
        "product_level_credit_limit":99674131006.050201416,
        "product_level_credit_outstanding":3545011.2102000001
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "product_name":"Productive Credit - KMK ank EFEKTIF IDR",
        "product_level_credit_limit":0.0,
        "product_level_credit_outstanding":0.0
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "product_name":"Productive Credit - KMK Bank EFEKTIF USD",
        "product_level_credit_limit":0.0,
        "product_level_credit_outstanding":0.0
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "product_name":"Productive Credit - Term Loan Bank Efektif USD",
        "product_level_credit_limit":0.0,
        "product_level_credit_outstanding":0.0
    },
    {
        "company_name":"PERTAMINA (PERSERO)",
        "group_company":"PERTAMINA GROUP",
        "product_name":"Productive Credit - Trust Receipt USD",
        "product_level_credit_limit":0.0,
        "product_level_credit_outstanding":0.0
    },
    {
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "product_name":"Import LC_Product added for UAT",
        "product_level_credit_limit":515833908471.1989746094,
        "product_level_credit_outstanding":443825820201.1400146484
    },
    {
        "company_name":"SEMEN INDONESIA",
        "group_company":"SEMEN INDONESIA GROUP",
        "product_name":"Productive Credit - TL Bank KORPORASI IDR",
        "product_level_credit_limit":3369665478074.9599609375,
        "product_level_credit_outstanding":2720091410012.8798828125
    },
    {
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "product_name":"Import LC_Product added for UAT",
        "product_level_credit_limit":772370425112.3967285156,
        "product_level_credit_outstanding":5529499757884.859375
    },
    {
        "company_name":"UNITED TRACTORS",
        "group_company":"ASTRA - UNITED TRACTORS",
        "product_name":"Productive Credit - KMK Bank KORPORASI USD",
        "product_level_credit_limit":28076923.0758000016,
        "product_level_credit_outstanding":301265384603.333984375
    }
]
